import React from "react";
import { Hero, Section, CTA } from "../components/Page/Page.js";
import { guide } from "../data/guide.js";

export default function GuideScreen() {
  return (
    <>
      <Hero eyebrow="Buyers / Guide" title="Buying carbon credits for the first time" text="A plain guide for companies new to the market: what to buy, what to ask, and how to avoid common mistakes." cta="Talk to us about your needs" />
      <Section title="In this guide" n="00">
        <nav className="pg-toc">
          {guide.map(([id, t], i) => <a key={id} href={`#${id}`}>{String(i + 1).padStart(2, "0")}  {t}</a>)}
        </nav>
      </Section>
      <Section alt>
        <div className="pg-article">
          {guide.map(([id, t, body]) => (
            <div key={id}>
              <h3 id={id}>{t}</h3>
              {body.map((p, i) => <p key={i}>{p}</p>)}
            </div>
          ))}
        </div>
      </Section>
      <CTA text="Want help choosing credits?" />
    </>
  );
}
